import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent {

  @Input() public pageTitle: string;
}
